import { complianceRestrictionsStyle } from "@WhiteCap/Widgets/ProductDetailsPage/ComplianceRestrictions";
import { css } from "styled-components";

/*

**** EC-231 Product Details Page (PDP) ****

*** Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments. */
complianceRestrictionsStyle.title = {
    css: css`
        border-bottom: 0.1rem solid rgb(255, 204, 51);
        font-weight: 500;
        font-size: 16px;
        text-transform: uppercase;
        margin-bottom: 18px;
        box-sizing: border-box;
        display: inline-flex;
    `,
};
complianceRestrictionsStyle.complianceContainer = {
    css: css`
        display: flex;
        column-gap: 10px;
        svg {
            fill: #ffcc33;
            height: 20px !important;
            width: 20px !important;
            margin-top: 10px;
        }
        div {
        }
    `,
};

complianceRestrictionsStyle.mainContainer = {
    css: css`
        width: 100%;
    `,
};
complianceRestrictionsStyle.warning = {
    css: css`
        font-size: 15px;
        font-weight: 700;
        color: #005eaa;
    `,
};
complianceRestrictionsStyle.warningMessage = {
    css: css`
        font-size: 15px;
    `,
};
/* *** End: Dynamic CSS refactoring complete. Apply future updates here instead of the CMS.*/
